<template>
  <div>
    <div class="res-info-item">
      <span class="res-info-label">Location:</span> {{ locationFormatted }}<br />
    </div>
    <div class="res-info-item">
      <span class="res-info-label">Date:</span> {{ dateFormatted }}<br />
    </div>
    <div class="res-info-item">
      <span class="res-info-label">Party Size:</span> {{ partySize }}<br />
    </div>
    <div class="res-info-item">
      <span class="res-info-label">Time:</span> {{ suggestionSelected }}pm
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  name: "infoRes",
  computed: {
    ...mapState({
      location: state => state.availability.location,
      date: state => state.availability.date,
      partySize: state => state.availability.partySize,
      time: state => state.availability.time,
      suggestionSelected: state => state.availability.suggestedTimes.selected,
    }),
    dateFormatted() {
      return moment( this.date, 'MM-DD-YYYY' ).format( 'ddd, MM-DD-YYYY' )
    },
    locationFormatted() {
      return _.capitalize( this.location )
    }
  }
}

</script>

<style scoped lang="scss">
.res-info-item {
  float: left;
  margin: 5px;

  @media screen and (min-width: 426px) and (max-width: 768px) {
    margin: 3px;
    margin-left: 9%;
    width: 40%;
  }
  @media screen and (max-width: 425px) {
    margin: 3px;
    width: 100%;
  }
}

.res-info-item {
  font-size: 125%;
  font-weight: bold;
  color: #a71313;
}

.res-info-label {
  font-weight: normal;
  color: #000;
}
</style>